<script>
  import { users } from "./users"
  import timezones from "./timezones"
  import MakeUser from "./MakeUser.svelte"
  import { reset, makeUser } from "./users"
  import { uniq, chunk } from "lodash-es"
  import { getTimezoneOffset } from "date-fns-tz"
  
  // let users = []
  let calcs = 0
  let set = [], average = 0
  let open = false
  let editingUser = {}

  const makeUsers = () => {
    calcs = 0
    reset()
    $users = Array(16).fill().map(_ => makeUser())
  }

  const clear = () => {
    if (confirm("Are you sure you want to delete all users and matches?")) {
      calcs = 0
      average = 0
      $users = []
      set = []
    }
  }

  // makeUsers()
  
  const dayParts = {
    morning: [6, 12],
    afternoon: [12, 18],
    evening: [18, 24]
  }
  
  const calcDayPartsOverlap = (d1, d2) => {
    calcs++
    
    if (d1[1] < d1[0]) d1[1] += 24
    if (d2[1] < d2[0]) d2[1] += 24
    
    if (d1[0] < d2[0] && d2[0] < d1[1])
      return d1[1] - d2[0]
    
    if (d2[0] < d1[0] && d1[0] < d2[1])
      return d2[1] - d1[0]
    
    return 0
  }
  
  const calcOverlap = (u1, u2, weekPart) => {
    const offset1 = getTimezoneOffset(u1.tz) / 3.6e6
    const offset2 = getTimezoneOffset(u2.tz) / 3.6e6
    
    const dayParts1 = u1.availability[weekPart].map(
      p => dayParts[p].map(t => (24 + t - offset1) % 24)
    )
    
    const dayParts2 = u2.availability[weekPart].map(
      p => dayParts[p].map(t => (24 + t - offset2) % 24)
    )
    
    return dayParts1.reduce((sum, d1) => {
      return sum + dayParts2.reduce((sum, d2) => {
        return sum + calcDayPartsOverlap(d1, d2)
      }, 0)
    }, 0)
  }

  const findLeastCommonName = links => {
    const names = uniq(links.flat().filter(item => typeof item === "string"))
    const matchesObj = names.reduce((obj, name) => {
      const matches = links.filter(link => link.includes(name))
      obj[name] = matches
      return obj
    }, {})

    const leastCommonName = Object.keys(matchesObj).reduce(
      (key, v) => matchesObj[v].length < matchesObj[key].length ? v : key
    )

    return [ leastCommonName, matchesObj[leastCommonName] ]
  }

  const findSets = (links, average = 0, count = 0) => {
    if (links.length === 1) {
      const link = [ ...links[0] ]
      link[2] += average
      return link
    }
		
		if (links.length === 0) return average

    let sets = []
    const [ leastCommonName, matches ] = findLeastCommonName(links)

    for (const match of matches) {
      const names = uniq([ match[0], match[1], leastCommonName ]).sort()
      const remainingLinks = links.filter(
        link => !link.some(m => names.includes(m))
      )
      const newAverage = (average * count + match[2]) / (count + 1)
			let nested = findSets(remainingLinks, newAverage, count + 1)
			if (!Array.isArray(nested[0])) nested = [nested]
      for (const branch of nested) {
				sets.push(names.concat(branch))
			}
    }

    return sets
  }
	
	const calculate = () => {
    if ($users.length < 2)
      return alert("Not enough users to make matches")

    const overlaps = $users.reduce((result, u1) => {
      for (let u2 of $users) {
        if (u1 === u2) continue
        const names = [u1.name, u2.name].sort()
        const index = `${names[0]} - ${names[1]}`
        if (result[index] != null) continue
        const overlap = calcOverlap(u1, u2, "week")
          + calcOverlap(u1, u2, "weekend")
        if (overlap === 0) continue
        result[index] = overlap
      }
      
      return result
    }, {})
    
    const links = Object.entries(overlaps).map(
      ([key, value]) => key.split(" - ").concat([value])
    )

    let sets = findSets(links) || []

    if (!sets.length)
      return alert("No matches found...")

    if (!Array.isArray(sets[0]))
      sets = [sets]

    sets.sort((a, b) => {
      return b.length - a.length || b.slice(-1)[0] - a.slice(-1)[0]
    }).slice(0,20)

    average = Math.round(sets[0].pop())
    set = chunk(sets[0], 2)
  }

  const add = () => {
    editingUser = {
      name: "", email: "",
      tz: "", availability: {
        week: [], weekend: []
      }
    }

    $users.push(editingUser)
    open = true
  }

  const remove = user => {
    const index = $users.findIndex(u => u === user)
    $users.splice(index, 1)
    $users = $users
  }

  const edit = user => {
    editingUser = user
    open = true
  }

  $: if (!open) {
    $users = $users.filter(user => user.tz)
  }

  const save = () => $users = $users
</script>

<div class="buttons">
  <button class="green" on:click={calculate}>Calculate matches</button>
  <button on:click={makeUsers}>Generate random users to test logic</button>
  <button class="red" on:click={clear}>Delete all users and matches</button>
</div>

<ul>
  {#each set as couple}
    <li>{couple[0]} - {couple[1]}</li>
  {/each}
</ul>

<p>Average hours overlap: {average}</p>

<table>
  <thead>
    <th>Name</th>
    <th>Email</th>
    <th>Timezone</th>
    <th>Actions</th>
  </thead>

  <tbody>
    {#each $users as user}
      <tr>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td>{timezones.find(tz => user.tz === tz.value).label}</td>
        <td>
          <button on:click={_ => edit(user)}>Edit</button>
          <button on:click={_ => remove(user)}>Remove</button>
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<MakeUser bind:open={open} bind:user={editingUser} on:save={save} />

<button on:click={add}>Add new user</button>

<style>
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  button {
    border: none;
    border-radius: 4px;
    padding: .5rem 1rem;
  }

  td {
    padding: .5rem 1rem;
  }

  .green {
    background: MediumSeaGreen;
    color: white;
  }

  .red {
    background: crimson;
    color: white;
  }
</style>